module.exports = __webpack_public_path__ + "img/logo5.84215a7d.png";